export const InventoryActionTypes = {
    INVENTORY_DATA_FIRST: '@@auth/INVENTORY_DATA_FIRST',
    INVENTORY_DATA_LOADING: '@@auth/INVENTORY_DATA_LOADING',
    INVENTORY_DATA_SUCCESS: '@@auth/INVENTORY_DATA_SUCCESS',
    INVENTORY_DATA_ERROR: '@@auth/INVENTORY_DATA_ERROR',


    UPDATE_INVENTORY_DATA_FIRST: '@@auth/UPDATE_INVENTORY_DATA_FIRST',
    UPDATE_INVENTORY_DATA_LOADING: '@@auth/UPDATE_INVENTORY_DATA_LOADING',
    UPDATE_INVENTORY_DATA_SUCCESS: '@@auth/UPDATE_INVENTORY_DATA_SUCCESS',
    UPDATE_INVENTORY_DATA_ERROR: '@@auth/UPDATE_INVENTORY_DATA_ERROR',
    UPDATE_INVENTORY_DATA_RESET: '@@auth/UPDATE_INVENTORY_DATA_RESET',

    PROFIT_LOSS_DATA_FIRST: '@@auth/PROFIT_LOSS_DATA_FIRST',
    PROFIT_LOSS_DATA_LOADING: '@@auth/PROFIT_LOSS_DATA_LOADING',
    PROFIT_LOSS_DATA_SUCCESS: '@@auth/PROFIT_LOSS_DATA_SUCCESS',
    PROFIT_LOSS_DATA_ERROR: '@@auth/PROFIT_LOSS_DATA_ERROR',
    
    
    STATE_EMPTY_FIRST: '@@auth/STATE_EMPTY_FIRST',
    STATE_EMPTY_SUCCESS: '@@auth/STATE_EMPTY_SUCCESS',

};
